const KEY = "bergler.impersonate.userId";

// Impersonate-State liegt in sessionStorage — bei Tab-Close weg.
// Ein versehentliches Dauer-Impersonieren ueber Tage ist damit ausgeschlossen.

export function readImpersonate(): string | null {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(KEY);
}

export function writeImpersonate(userId: string): void {
  window.sessionStorage.setItem(KEY, userId);
}

export function clearImpersonate(): void {
  window.sessionStorage.removeItem(KEY);
}

/**
 * Gehoert eine gespeicherte Spur zu der Vertretung, die DIESER Tab fuehrt?
 *
 * VTR-7. Im `localStorage` liegen Spuren, die allen Tabs gemeinsam gehoeren
 * (der gespiegelte Abfrage-Cache und `bergler.last-known-user`); die
 * Vertretung dagegen lebt im `sessionStorage` genau EINES Tabs. Wer eine
 * gemeinsame Spur liest, muss deshalb fragen koennen, unter welcher Vertretung
 * sie geschrieben wurde — sonst uebernimmt der vertretende Tab den Stand des
 * eigenen Anmelders (Daniels Befund: seine vier Karten unter Marvins Namen).
 *
 * Die Frage ist SYNCHRON zu beantworten, ohne `/api/me`. Genau darin liegt der
 * Wert: die Spur wird geprueft, bevor das erste Bild gezeichnet ist.
 *
 * Der EINE Ort fuer diese Regel — beide Spuren fragen hier.
 */
export function belongsToCurrentImpersonation(
  vertretenerId: string | null,
): boolean {
  return vertretenerId === readImpersonate();
}
